import React from "react";
import locale from "locale";
import {
    ListGroup,
    ListGroupItem,
    ButtonToolbar,
    Glyphicon,
    Button,
    Well,
} from "react-bootstrap";

import { CUSTOM_TEMPLATE_TYPE } from "../models";

const LettersList = ({ templates, onEdit, onPreview, onDelete }) => {
    if (!templates?.length) {
        return (
            <Well style={{ marginTop: "15px" }}>
                {locale("email.noTemplatesFound")}
            </Well>
        );
    }

    const isCustomTemplate = (template) =>
        template?.type === CUSTOM_TEMPLATE_TYPE;

    function handleConfirmRemove(template) {
        const allow = confirm(`${locale("email.removeTemplate")}?`);

        allow && onDelete(template);
    }

    return (
        <section>
            <ListGroup
                className="mail-block-list"
                style={{ marginTop: "15px" }}
            >
                {templates.map((template) => (
                    <ListGroupItem key={template.id + template.name}>
                        <div className="mail-block-list-item">
                            <div className="mail-block-list-item__info">
                                <h4>{template.name}</h4>
                            </div>
                            <ButtonToolbar>
                                <Button onClick={() => onPreview(template)}>
                                    <Glyphicon glyph="eye-open" />
                                </Button>
                                <Button
                                    bsStyle="success"
                                    onClick={() => onEdit(template)}
                                >
                                    <Glyphicon glyph="edit" />
                                </Button>
                                {isCustomTemplate(template) && (
                                    <>
                                        <Button
                                            bsStyle="danger"
                                            onClick={() =>
                                                handleConfirmRemove(template)
                                            }
                                        >
                                            <Glyphicon glyph="trash" />
                                        </Button>
                                    </>
                                )}
                            </ButtonToolbar>
                        </div>
                    </ListGroupItem>
                ))}
            </ListGroup>
        </section>
    );
};

export default LettersList;
